import { GroupBase, CommonPropsAndClassName } from 'react-select'

import { IconNotebook } from '@customTypes'

export type SelectComponents =
  | 'clearIndicator'
  | 'container'
  | 'control'
  | 'dropdownIndicator'
  | 'group'
  | 'groupHeading'
  | 'indicatorsContainer'
  | 'indicatorSeparator'
  | 'input'
  | 'inputContainer'
  | 'loadingIndicator'
  | 'loadingMessage'
  | 'menu'
  | 'menuNotice'
  | 'menuList'
  | 'menuPortal'
  | 'multiValue'
  | 'multiValueLabel'
  | 'multiValueRemove'
  | 'noOptionsMessage'
  | 'option'
  | 'placeholder'
  | 'singleValue'
  | 'valueContainer'

export type ComponentClassName =
  | 'clear-indicator'
  | 'container'
  | 'control'
  | 'dropdown-indicator'
  | 'group'
  | 'group-heading'
  | 'indicators'
  | 'indicator-separator'
  | 'input'
  | 'input-container'
  | 'loading-indicator'
  | 'loading-message'
  | 'menu'
  | 'menu-notice'
  | 'menu-notice--no-options'
  | 'menu-list'
  | 'menu-portal'
  | 'multi-value'
  | 'multi-value__label'
  | 'multi-value__remove'
  | 'option'
  | 'placeholder'
  | 'single-value'
  | 'value-container'

export type ComponentState =
  | 'has-value'
  | 'no-options'
  | 'menu-is-open'
  | 'is-focused'
  | 'is-selected'
  | 'is-shown'
  | 'is-stretched'
  | 'is-fluid'
  | 'is-shrunk'

export type SelectComponent = Capitalize<ComponentClassName>

export interface OptionInterface {
  label: string
  value: string | number
}

export type SelectComponentProps<
  Option extends OptionInterface = OptionInterface,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
> = CommonPropsAndClassName<Option, IsMulti, Group>

export interface ComponentConfig {
  isMulti?: boolean
  dropdown?: {
    iconClosed: IconNotebook
    iconOpen?: IconNotebook
  }
  separator?: {
    shouldHide?: boolean
  }
  clearIndicator?: {
    title?: string
  }
  lastSelectedOptions?: (string | number)[]
  menuList: {
    shouldVirtualize?: boolean
  }
}

export function isGroup<
  Option extends OptionInterface,
  Group extends GroupBase<Option>
>(options: Option | Group): options is Group {
  return (options as Group).options !== undefined
}

export type LabelProps = {
  htmlFor: string
  label?: string
  float?: boolean
  active?: boolean
  hasIcon?: boolean
}
